"use client";

import { cn } from "@/lib/utils";
import type { User } from "@/lib/types";

export function Avatar({
  user,
  size = 20,
  className,
}: {
  user: User | null | undefined;
  size?: number;
  className?: string;
}) {
  if (!user) {
    return (
      <div
        className={cn(
          "flex items-center justify-center rounded-full border border-dashed text-[var(--fg-muted)] border-[var(--border-strong)]",
          className
        )}
        style={{ width: size, height: size, fontSize: Math.max(9, size * 0.42) }}
      >
        ?
      </div>
    );
  }
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-medium text-white select-none",
        className
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(9, size * 0.42),
        background: `linear-gradient(135deg, ${user.color}, color-mix(in srgb, ${user.color} 55%, #000))`,
      }}
      title={user.name}
    >
      {user.initials}
    </div>
  );
}

export function AvatarStack({
  users,
  size = 20,
  max = 3,
}: {
  users: (User | null | undefined)[];
  size?: number;
  max?: number;
}) {
  const shown = users.filter(Boolean).slice(0, max) as User[];
  const extra = users.filter(Boolean).length - shown.length;
  return (
    <div className="flex items-center">
      {shown.map((u, i) => (
        <div
          key={u.id}
          className="rounded-full ring-2 ring-[var(--bg)]"
          style={{ marginLeft: i === 0 ? 0 : -size / 3 }}
        >
          <Avatar user={u} size={size} />
        </div>
      ))}
      {extra > 0 && (
        <div
          className="flex items-center justify-center rounded-full ring-2 ring-[var(--bg)] bg-[var(--bg-hover)] text-[var(--fg-tertiary)]"
          style={{
            width: size,
            height: size,
            fontSize: Math.max(9, size * 0.4),
            marginLeft: -size / 3,
          }}
        >
          +{extra}
        </div>
      )}
    </div>
  );
}
